import { storeToRefs } from 'pinia'
import { useFeatureFlagsStore } from '@/store/feature-flags'
import type { KnownFlag } from '@/app/core/services/feature-flags'
import type { IFlagsmithValue } from '@flagsmith/flagsmith'

/**
 * API reactiva de feature flags para componentes Vue.
 *
 * @example
 * const { isEnabled } = useFeatureFlags()
 * // en template: v-if="isEnabled('new_payment_slips')"
 */
export default function useFeatureFlags() {
  const store = useFeatureFlagsStore()
  const { flags, ready } = storeToRefs(store)

  /**
   * Indica si una flag booleana esta habilitada para el contexto actual
   * (workspace + compania activa).
   */
  const isEnabled = (key: KnownFlag | string): boolean => store.isEnabled(key)

  /**
   * Devuelve el valor de una remote-config flag, o null si no existe.
   */
  const getValue = <T extends IFlagsmithValue = IFlagsmithValue>(
    key: KnownFlag | string
  ): T => store.value(key) as T

  return { flags, ready, isEnabled, getValue }
}
